// const baseURL = "http://127.0.0.1:8000";
// const baseURL = "http://54.172.136.232:8000";
const baseURL = "https://api.dynamoedge.com/django-api";
const apiURL = `${baseURL}/api/v1`;
const mediaURL = `${baseURL}/media`;

export { apiURL, mediaURL };
